import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatSubProductModel } from 'src/app/model/cat-sub-product.model';
import { CatSubProductService } from 'src/app/services/cat-sub-product.service';

@Component({
  selector: 'app-modal-sub-product',
  templateUrl: './modal-sub-product.component.html',
  styleUrls: ['./modal-sub-product.component.css']
})
export class ModalSubProductComponent implements OnInit {
  @Input() subProduct: CatSubProductModel;
  @Input() products: any[] = [];
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private subProductService: CatSubProductService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.subProduct.iActiveId = this.subProduct.iActiveId ? 0 : 1;
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (this.productError()) errors.push('Necesita seleccionar un producto.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      this.subProduct.vDescription = this.subProduct.vDescription.toUpperCase();
      let userName = localStorage.getItem('com_userName');
      this.subProductService.save(userName, this.subProduct)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El subproducto se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar el subproducto.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar el subproducto.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.subProduct.vDescription || this.subProduct.vDescription.trim() === '';
  productError = () => !this.subProduct.iCatProductId;
}
